var jade = require("/home/runner/work/banquetNinja/banquetNinja/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<ninja-grid no-data-text=\"No timeline yet...\" grid-title=\"Event Timeline\" doc-svc=\"vm.docSvc\" list=\"vm.docSvc.doc.eventSteps\" create-method=\"addTimeline\" update-method=\"editTimeline\" delete-method=\"removeTimeline\" add-toggle=\"vm.sideTab.timeline\" fields=\"{time: {header: 'Start Time', input: 'timefield', order: 10, width: 15, type: 'time'},  \n                endTime: {header: 'End Time', input: 'timefield', order: 15, width: 15, type: 'time'},\n                duration: {header: 'Duration', input: 'nonedit', order: 20, width: 15, type: 'string'}, \n                description: {header: 'Description', input: 'textarea', order: 30, width: 60, type: 'string'}}\"></ninja-grid>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/features/events/contracts/tabs/tab-timeline.jade
// module id = 274
// module chunks = 0